import flattenDeep from "lodash/flattenDeep";
import { getLangList } from '@/lib/i18n';

export const excelTitleUser = [
  'username',
  'roleName',
  'birthday',
  'nameCn',
  'nameEn',
  'gender',
  'identityNumber',
  'residenceAddress',
  'mailingAddress',
  'school',
  'grade',
  'classroom',
  'seatNumber',
  'allergy',
  'cramClassName',
  'cramSeat',
  'isLunch',
  'isSnack',
  'extension',
  'departmentName',
  'dueDate',
  'businessEmail',
  'personalEmail',
  'accessCardNumber',
  'cellPhoneNumber',
  'year',
  'semesterName',
];

export const getFileTitleObject = (workKey: string, resignKey: string) => {
  const organizationT: any = getLangList("organization");
  return {
    work: organizationT[workKey],
    workAndResign: `${organizationT[workKey]} + ${organizationT[resignKey]}`,
  };
};

export const exportUserOptions = (fileTitleObject: { work: string, workAndResign: string }) => ([
  { key: 'false', label: fileTitleObject.work },
  { key: 'true', label: fileTitleObject.workAndResign },
]);

export const getClassDataArray = (allClassObject: any): any => {
  const classDataArray = flattenDeep(Object.entries(allClassObject).map(([key, value = []]: any) => value))
    .map((item: any) => ({ label: item.className, value: item.classId }))
    .sort((a, b) => a.label < b.label ? -1 : 1);
  return classDataArray;
};